import { GetUserByIdReq } from '../types/getUserByIdReq';
import axiosClient from './axiosClient';

export const adminApi = {
  consumerSummary: (payload: any) =>
    axiosClient.post('/consumer-summary', payload).then((r) => r.data),

  getUserById: (payload: GetUserByIdReq) =>
    axiosClient.post('/get-user-by-id', payload).then((r) => r.data),

  patchUser: (payload: any) => axiosClient.patch('/patch-user', payload).then((r) => r.data),
};
